(function () {
  const closePopUp = function () {
    document.getElementById("cookie-popup").style.display = 'none';
    localStorage.setItem('cookieAccepted', 'true');
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (!localStorage.getItem('cookieAccepted')) {
      document.getElementById("cookie-popup").style.display = 'flex';
    }

    const closeBtn = document.querySelector('.cookie-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopUp);
    }
  })
})($)